import {Component, ElementRef, Input, NgZone} from '@angular/core';
import {WebsiteSpotPage} from '../../pages/sync/website-spot/website-spot';

@Component({
    selector: 'spotus-anime',
    templateUrl: 'spotus-anime.html',
    providers: []
})
export class SpotusAnime {

    @Input('hpage') hpage: WebsiteSpotPage;
    @Input('autoplay') autoplay: boolean;
    @Input('loop') loop: boolean;

    classSpot: string;
    classUs: string;
    classApp: string;

    constructor(public element: ElementRef, public ngZone: NgZone) {

    }

    ionViewDidEnter() {

        if (this.autoplay) this.animeLogo();

    }

    animeLogo() {

        if (this.classSpot) return;

        setTimeout(() => {
            this.ngZone.run(() => {
                this.classSpot = 'fadeInLeft';
            });
        },  0);

        setTimeout(() => {
            this.ngZone.run(() => {
                this.classUs = 'fadeInUp';
            });
        },    1500);

        setTimeout(() => {
            this.ngZone.run(() => {
                this.classApp = 'fadeInRight';
            });
        }, 1500);

    }

    deanimeLogo() {

        if (!this.classSpot && this.loop) return;

        setTimeout(() => this.classSpot = '',    0);
        setTimeout(() => this.classUs   = '',    0);
        setTimeout(() => this.classApp  = '',    0);

    }

}



// WEBPACK FOOTER //
// ./src/components/spotus-anime/spotus-anime.ts